import { SimpleLayout, useLayout } from '@approvalmax/ui/src/components';
import { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet';
import { storageService } from 'services/storage';

import { Content, LogoutAcceptInvitation } from './resources/components';
import { messages } from './resources/messages';

const Page = () => {
    useLayout({ containerMinSize: 'xxsmall' });

    const [showLogoutInvitation, setShowLogoutInvitation] = useState(storageService.authenticated());

    const onLogout = useCallback(() => {
        setShowLogoutInvitation(false);
    }, []);

    return (
        <SimpleLayout size='xsmall'>
            <Helmet>
                <title>{messages.title}</title>
            </Helmet>

            <SimpleLayout.Content>
                {showLogoutInvitation ? <LogoutAcceptInvitation onLogout={onLogout} /> : <Content />}
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

export default Page;
